<template>
  <div class="loading" v-show="loading.count">
    <div class="loading__modal"></div>
    <i class="el-icon-loading"></i>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: "Loading",
    computed: {
      ...mapState(['loading'])
    }
  }
</script>

<style lang="scss">
  .loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;

    &__modal {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.4);
    }

    i {
      font-size: 50px;
      color: #fff;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -25px;
      margin-left: -25px;
    }
  }
</style>